export * from "./getXSellingPopupDataForCart";
